import styled from '@emotion/styled';
import { ListItemText } from '@mui/material';

const UploadMenuItemContent = styled(ListItemText)(({ theme }) => ({
  '> .MuiTypography-root': {
    display: 'flex',
    alignItems: 'center',
    '> span': {
      marginRight: 24,
      em: {
        color: theme.palette.text.secondary,
        fontSize: 14,
        fontStyle: 'normal',
      },
    },
    '.MuiButton-root, .MuiIconButton-root': {
      marginLeft: 'auto',
    },
  },
}));

export default UploadMenuItemContent;
